import { api } from '../api';
/**
 * 빙고 이벤트 API
 */
export const BingoApi = {
	// GET
	GetBingoCount: (event_se, member_se) => api.get(`/api/bingo/count?event_se=${event_se}&&member_se=${member_se}`),
	GetBingoCompleteState: (event_se, member_se) => api.get(`/api/bingo/state?event_se=${event_se}&&member_se=${member_se}`),
	GetBingoBoard: (event_se, member_se) => api.get(`/api/bingo/board?event_se=${event_se}&&member_se=${member_se}`),

	// POST
	PostBingoStart: (data) => api.post(`/api/bingo/start`, data),
	PostBingoBoardReward: (data) => api.post(`/api/bingo/reward`, data),
	PostNewBingoBoard: (data) => api.post(`/api/bingo/board`, data),
};